<template>
  <v-container fluid fill-height class="background fill-height">
    <v-card class="white mx-auto" width="30vw" height="50vh" min-height="480px">
      
      <div class="white mb-3" >
        <v-img max-width="20vw" class="mx-auto" src="../assets/DigiWheel_Logo_Evolution_Company_RGB_Yellow_Black.svg"/>
      </div>

      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        class="text-center"
      >
        <v-text-field
          v-model="username"
          :placeholder="$t('login.username')"
          class="mb-n2 rounded-lg mx-auto"
          style="width: 70%"
          outlined
          density="compact"
          single-line
          data-test="email-input"
        ></v-text-field>
    
        <v-text-field
          v-model="password"
          :placeholder="$t('login.password')"
          class="mb-n2 rounded-lg mx-auto"
          style="width: 70%"
          outlined
          single-line
          density="compact"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          :rules="[passwordSecurityRule]"
          @click:append="showPassword = !showPassword"
          data-test="password-input"
        ></v-text-field>

        <v-btn
          style="width: 70%"
          color="black white--text"
          class="rounded-lg mb-3"
          :disabled="!valid || loading"
          :loading="loading"
          @click="loginClick()"
          data-test="btn-login"
        >
          {{ $t('login.enter') }}
        </v-btn>
        <router-link 
          to="/resetpassword" 
          class="reset-password-link"
        >
          {{ $t('login.reset') }}
        </router-link>
      </v-form>

    </v-card>
  </v-container>
</template>

  <script>
import { mapActions, mapGetters } from 'vuex';
import { isAuthenticated, logout } from '@/auth';
  export default {
    name: "LogIn",
    data: () => ({
      valid: false,
      username: '',
      password: '',
      showPassword: false,
      loading: false
    }),
    computed: {
      passwordSecurityRule() {
        return v => {
          if (!v) return true;
          const forbiddenChars = /<|>|&|'|"|`|\\||\\\\|{|}|\\[|\\]|\\(|\\)|;/;
          if (forbiddenChars.test(v)) {
            return 'Password contains invalid characters';
          }
          return true;
        };
      }
    },
    mounted() {
      this.setLoginPage(true);
      
      // If user is already authenticated when reaching login page (e.g., via back button),
      // log them out to prevent navigation issues
      if (isAuthenticated()) {
        logout();
        this.$toast.info("You have been logged out.");
      }
    },
    computed: {
      ...mapGetters([
        "getLoginFailed",
      ]),
      loginFailed() {
        return this.getLoginFailed;
      },
    },
    methods: {
      ...mapActions(["login", "setLoginPage"]),
      async loginClick() {
        this.loading = true;
        try {
          await this.login({'username': this.username.trim(), 'password': this.password.trim() });
          if (this.getLoginFailed) {
            this.$toast.error("Incorrect login. Please try again.");
          }
        } finally {
          this.loading = false;
        }
      }
    },
  };
  </script>
  
  <style scoped>
  .fadeout {
    animation: fadeout 2s forwards;
  }
  
  @keyframes fadeout {
    to {
      opacity: 0;
      visibility: hidden;
    }
  }

  .reset-password-link {
    display: block;
    text-align: center;
    color: #1976d2;
    text-decoration: none;
    font-size: 14px;
    margin-top: 10px;
  }

  .reset-password-link:hover {
    text-decoration: underline;
  }

  </style>
  